import type { Facet } from 'src/redux/productsQuery/types/Facet';

export const getListingsFacetsAsURLSearchParams = (facets: Facet[]): URLSearchParams => {
  const facetsWithActiveOptions = (facets || []).filter((facet) => {
    return facet.options.some((option) => option.active);
  });

  return facetsWithActiveOptions.reduce((urlParams, facet) => {
    facet.options.forEach((option) => {
      if (option.active) {
        const shortenedKey = facet.key.replace(/^attributes\./, 'a.');
        const paramName = `f_${shortenedKey}`;
        urlParams.append(paramName, option.value);
      }
    });

    return urlParams;
  }, new URLSearchParams());
};
